import React from 'react'
import { connect } from 'react-redux'
import {
  Dialog,
  DialogContent,
  DialogTitle
} from '@material-ui/core'
import { HourglassFull } from '@material-ui/icons'
import PdsSpinner from '../components/PdsSpinner.js'
import { HEADER_BACKGROUND } from '../styles.js'

const ProgressDialog = ({ title, status, notice }) => {
  return (
    <Dialog open fullWidth maxWidth='xs'>
      <DialogTitle style={titleStyle}>
        <HourglassFull style={iconStyle} />
        <div style={titleContentStyle}>
          {title}
        </div>
      </DialogTitle>
      <DialogContent style={contentStyle}>
        <PdsSpinner size={20} space={8} />
        <div>
          {notice ? <div style={noticeStyle}>{notice}</div> : null}
          <div style={statusStyle}>
            {status}...
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

const titleStyle = {
  background: HEADER_BACKGROUND,
  color: 'white',
  paddingLeft: '10px',
  paddingTop: '4px',
  paddingBottom: '4px'
}

const iconStyle = {
  marginTop: '3px',
  float: 'left'
}

const titleContentStyle = {
  marginLeft: '30px'
}

const contentStyle = {
  padding: '15px',
  display: 'flex'
}

const statusStyle = {
  marginLeft: '15px',
  marginTop: '-3px',
  maxWidth: '320px'
}

const noticeStyle = {
  marginLeft: '15px',
  marginTop: '-3px',
  marginBottom: '8px',
  maxWidth: '320px',
  fontWeight: 'bold'
}

const mapStateToProps = (state) => {
  const { strings } = state.locale
  const title = strings[state.progress.title] || ''
  let status = strings[state.progress.status] || ''
  const { statusParam } = state.progress
  if (statusParam) {
    status = status.replace('%s', statusParam)
  }
  const notice = state.progress.title === 'PROGRESS_TITLE_SEND_AND_FILE'
    ? strings.SEND_AND_FILE_WAIT_MESSAGE
    : ''
  return { title, status, notice }
}

export default connect(mapStateToProps)(ProgressDialog)
